export default __webpack_public_path__ + "pypi/streamlit-1.13.0-py2.py3-none-any.whl";